 
 
 
 
 
 
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'copyrightsCaption');
    };
});



// WEBPACK FOOTER //
// ./model/copyright/copyrightCaption.js